import {
  Box,
  Card,
  CardContent,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import React, { useEffect, useState } from "react";
import CustomBreadcrumbs from "../../components/CustomBreadcrumbs";
import "./Usertype.css";
import functions from "../../utils/Api";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UsertypeDropdown from "../../components/UsertypeDropdown/UsertypeDropdown";
import { setUserType } from "../../Redux/persistApiDataSlice";

const Usertype = () => {
  const dispatcher = useDispatch();
  const navigate = useNavigate();
  const userTypeData = useSelector(
    (state) => state.persistApiData.userTypeData
  );
  const userType = useSelector((state) => state.persistApiData.userType);

  const breadCrumbData = [
    {
      label: "Home",
      path: "/cms/dashboard",
    },
  ];

  const handleRedirectBack = () => {
    navigate("/cms/users-list");
    dispatcher(setUserType(null));
  };

  const handleRedirect = (e) => {
    dispatcher(setUserType(e.target.value));
    if ([1, 3].includes(e.target.value)) {
      navigate("/cms/add-user");
    } else {
      navigate("/cms/add-vendor");
    }
  };

  return (
    <div className="usertype">
      <Box className="usertype-breadcrumb">
        <CustomBreadcrumbs items={breadCrumbData} currentLabel="Users" />
      </Box>
      <Card className="usertype-card">
        <CardContent>
          <Box className="usertype-main">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <IconButton
                aria-label="delete"
                size="medium"
                className="Admin-titleMain-iconBtn"
                onClick={handleRedirectBack}
                sx={{
                  "&:hover": {
                    background: "#004D72",
                    color: "#FFFFFF",
                  },
                }}
              >
                <ArrowBackIosNewOutlinedIcon
                  fontSize="inherit"
                  sx={{ width: "15px" }}
                />
              </IconButton>
              <Typography variant="h6" className="Admin-titleMain-label">
                <b> Create User</b>
              </Typography>
            </Box>
            <Divider />
            <Box className="usertype-form">
              <Grid container spacing={1}>
                <Grid item lg={3} xs={3}>
                  <UsertypeDropdown
                    title=""
                    value={userType}
                    data={userTypeData}
                    handleChange={handleRedirect}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default Usertype;
